import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useSpareForwardingStatus, SpareForwardingStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<SpareForwardingStatus>
    useData={useSpareForwardingStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
